var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReminderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 92,
    viewBox: "0 0 83 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1667 28.6667C67.1667 21.8594 64.4625 15.331 59.6491 10.5176C54.8356 5.70416 48.3072 3 41.5 3C34.6928 3 28.1644 5.70416 23.3509 10.5176C18.5375 15.331 15.8333 21.8594 15.8333 28.6667C15.8333 58.6111 3 67.1667 3 67.1667H80C80 67.1667 67.1667 58.6111 67.1667 28.6667Z",
    stroke: "#1F61DC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9183 84.2773C48.1662 85.5738 47.0867 86.65 45.7879 87.3981C44.4891 88.1462 43.0166 88.54 41.5177 88.54C40.0189 88.54 38.5464 88.1462 37.2476 87.3981C35.9487 86.65 34.8693 85.5738 34.1172 84.2773",
    stroke: "#1F61DC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderLogo);
export default __webpack_public_path__ + "static/media/ReminderLogo.585a6269413c76fe6e72da7942f09e8c.svg";
export { ForwardRef as ReactComponent };